export function autoAppyAppInitials(name = '') {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'AA';
}

const internalApplicationNames = new Set([
  'auto appy sso',
  'autoappy sso',
]);

export function autoAppySwitcherApps(apps = []) {
  if (!Array.isArray(apps)) return [];

  return apps.filter((app) => {
    if (!app || app.visible_in_switcher === false) return false;

    const applicationType = String(app.type || app.purpose || app.visibility || '').toLowerCase();
    if (['developer', 'internal'].includes(applicationType)) return false;

    return !internalApplicationNames.has(String(app.name || '').trim().toLowerCase());
  });
}

export function autoAppyAppLaunchUrl(app, workspaceId) {
  try {
    const url = new URL(app.frontend_url);
    if (app.key === 'main' && url.pathname === '/') url.pathname = '/app';
    if (workspaceId) url.searchParams.set(app.key === 'main' ? 'organisation' : 'workspace', workspaceId);
    return url.toString();
  } catch {
    return app.frontend_url || '#';
  }
}
